import React, { useEffect } from 'react';
import { Row, Button, Col, Space, message } from 'antd';
import { useMediaQuery } from 'react-responsive';

import NovaMatriz from '../../../../assets/icons/NovaMatriz/NovaMatriz';
import { Listagem } from './Listagem';
import { Formulario } from './Formulario';

import { useMatrizConsulta } from './context';

import * as S from './styles';

export function MatrizConsulta() {
  const isBigScreen = useMediaQuery({ query: '(min-width: 1200px)' });
  const {
    openForm,
    messagem,
    updateEditMatriz,
    updateOpenForm,
    updateMenssage,
  } = useMatrizConsulta();

  useEffect(() => {
    const msg = {
      type: '',
      msg: '',
      error: null,
    };
    if (messagem?.type === 'sucess') {
      message.success(messagem?.msg);
      updateMenssage(msg);
    }
    if (messagem?.type === 'error') {
      message.error(messagem?.msg);
      updateMenssage(msg);
    }
  }, [messagem, updateMenssage]);

  const handlerEdit = () => {
    updateEditMatriz(false);
    updateOpenForm(true);
  };

  const gridSpan = openForm ? 12 : 24;

  return (
    <Col
      style={{ width: '100%', paddingBottom: !isBigScreen && gridSpan && 24 }}
    >
      <Row
        style={{
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <S.StyledColMatriz span={24}>
          <h2>Matriz de Consulta</h2>
          <Button
            disabled={openForm}
            onClick={handlerEdit}
            style={{
              paddingLeft: '8px',
              height: '45px',
              fontWeight: 'bold',
              width: '150px',
              fontSize: '16px',
            }}
          >
            <Space
              style={{
                width: '100%',
                justifyContent: 'space-around',
                justifyItems: 'center',
                alignItems: 'center',
                padding: 0,
                border: 'none',
              }}
            >
              <NovaMatriz />
              Nova Matriz
            </Space>
          </Button>
        </S.StyledColMatriz>
      </Row>
      <Row
        justify="space-between"
        style={{
          width: '100%',
          paddingTop: '27px',
        }}
      >
        <Col
          span={gridSpan}
          xl={gridSpan}
          lg={24}
          md={24}
          sm={24}
          justify="center"
          style={{
            paddingRight: openForm && isBigScreen ? 22 : 0,
            marginBottom: openForm && !isBigScreen && 24,
          }}
        >
          <Listagem />
        </Col>
        {openForm && (
          <Col
            span={openForm ? 12 : 0}
            md={24}
            sm={24}
            lg={24}
            xl={gridSpan}
            justify="center"
          >
            <Formulario />
          </Col>
        )}
      </Row>
    </Col>
  );
}
